import { Component, ElementRef, inject, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroCog } from '@ng-icons/heroicons/outline';

@Component({
  imports: [RouterModule, NgIconComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  viewProviders: [
    provideIcons({
      heroCog,
    }),
  ],
})
export class AppComponent {
  readonly scrollContainer =
    viewChild<ElementRef<HTMLElement>>('scrollContainer');
  message = '';

  constructor() {
    const updates = inject(SwUpdate);

    updates.versionUpdates.subscribe((event) => {
      switch (event.type) {
        case 'VERSION_DETECTED':
          this.message = 'Downloading the new app version...';
          break;

        case 'VERSION_READY':
          this.message = 'New version ready to use. Reloading...';
          document.location.reload();
          break;
      }
    });
  }
}
